<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div v-if="questions.length > 0">
        <div v-for="question in questions" :key="question.id">
          <Question :quesData="question" :fetchPosts="fetch" :showFullScreen="showFullScreen"></Question>
        </div>
        <span
          v-if="questions.length != this.pagination.total_count"
          class="viewmore"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
          @click="fetch(true)"
        >
          More Questions
        </span>
      </div>
    </div>
    <div v-if="!loading && questions.length === 0" class="text-center">
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">
            <span class="dailog text-capitalize">
              {{ viewUser.role === "hospital" ? viewUser.hospital_info.hospital_name : viewUser.role === "clinic" ? viewUser.clinic_info.clinic_name : viewUser.display_name }}
            </span>
            has not answered any questions yet.
          </span>
        </div>
      </div>
    </div>
    <PostFullScreen ref="PostFullScreen" :postData="currentPostData" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory"
import Question from "../../../Patient/QA/Question"
import PostFullScreen from "../../../../Modals/activity/PostFullScreen.vue"
const QARepository = RepositoryFactory.get("qa")

export default {
  name: "PaitientQAAnwsered",
  components: {
    Question,
    PostFullScreen,
  },
  data() {
    return {
      loading: true,
      questions: [],
      pagination: { total_count: 0 },
      comment: "",
      currentPage: 1,
      limit: 5,
    }
  },

  created() {
    console.warn('view/PatientQAAnswered.vue is created');
  },

  mounted() {
    this.fetch()
  },

  methods: {
    /**
     * Fetch answered questions
     *
     */
    fetch(append = false) {
      const user = {
        id: this.$route.params.id,
        role: this.viewUser.role,
      }
      QARepository.getAnswers(user, this.currentCircle.id, this.currentPage, this.limit)
        .then(res => {
          if (res.status === 200) {
            if (append) {
              this.questions.push(...res.data.data.data)
            } else {
              this.loading = true
              if (res.data) {
                this.questions = res.data.data.data ? res.data.data.data : []
                this.loading = false
                this.pagination = res.data.data.paginator ? res.data.data.paginator : {}
              }
            }
            this.currentPage += 1
          } else {
            this.pagination = {}
          }
        })
        .catch(err => {})
    },
    pushToQa() {
      this.$router.push({ name: "QA" })
    },
  },
}
</script>

<style scoped lang="scss">
.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
  background: #f1f5f9;
  border-radius: 8px;
}
.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // width: 121px;
  padding: 12px 24px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/QA/PatientQAAnswered.vue